import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './FeaturesSection.css';
import featureIcon1 from '../assets/feature1.png';
import featureIcon2 from '../assets/feature2.png';
import featureIcon3 from '../assets/feature3.png';
import featureIcon4 from '../assets/feature4.png';
import featureIcon5 from '../assets/feature5.png';
import featureIcon6 from '../assets/feature6.png';
import featureIcon7 from '../assets/feature7.png';
import featureIcon8 from '../assets/feature8.png';
import featureIcon9 from '../assets/feature9.png';
import featureIcon10 from '../assets/feature10.png';
import featureIcon11 from '../assets/feature11.png';
import featureIcon12 from '../assets/feature12.png';
import featureVideo1 from '../assets/feature-video1.png';

const features = [
  {
    icon: featureIcon1,
    title: 'Under-Chassis and Wheel Cleaning',
    video: featureVideo1,
    contentTitle: 'Under-Chassis and Wheel Cleaning',
    content: `Equipped with an advanced high-pressure system operating at 80 kg, this feature 
delivers precise chemical application to effectively clean the Under chassis, lower side 
panels, wheels, and tires. The targeted wheel cleaning system ensures thorough 
removal of dirt, grime, and sediment from all critical areas. `,
  },
  { icon: featureIcon2, title: 'LAVA Foam Application System ', video: featureVideo1, contentTitle: 'LAVA Foam Application System ', content: `The LAVA Foam shampoo spraying system dispenses a thick, silky foam that maximizes 
surface contact for enhanced cleaning performance. This rich foam effectively loosens 
and removes contaminants from the vehicle’s exterior, ensuring a deep and uniform 
clean. 
` },
  { icon: featureIcon3, title: 'Hi-Gloss Shampoo Application System', video: featureVideo1, contentTitle: 'Hi-Gloss Shampoo Application System', content: `The Hi-Gloss Shampoo system delivers a dense, high-viscosity foam that enhances 
surface moisture and ensures thorough contact with dirt and contaminants. Its 
advanced formulation improves cleaning efficiency, minimizes the need for repeated 
scrubbing, and supports long-lasting vehicle surface maintenance.` },
  { icon: featureIcon4, title: 'High-Pressure Rinse System', video: featureVideo1, contentTitle: 'High-Pressure Rinse System', content: `Featuring German P+F ultrasonic sensing technology, the system ensures optimized 
flushing distance and increased water pressure for superior cleaning performance. Its 
precision design allows maximum coverage at various angles, effectively eliminating 
blind spots and ensuring a thorough rinse of the entire vehicle body. ` },
  { icon: featureIcon5, title: 'Hydrophobic Spray Coating', video: featureVideo1, contentTitle: 'Hydrophobic Spray Coating', content:  `The Hydrophobic Spray Coating forms a durable, high-molecular polymer layer on the 
vehicle’s paint surface, creating a protective film with a smooth, water-repellent finish. 
This coating enhances gloss while providing effective protection against moisture, 
contaminants, and environmental elements.` },
  { icon: featureIcon6, title: 'Chemical Mixing System ', video: featureVideo1, contentTitle: 'Chemical Mixing System ', content: `This fully automated system features precision metering pumps and adjustable mixing 
ratios to ensure accurate chemical dosing. With an efficient design that consumes only 
20–50 ml of each chemical per wash, it delivers optimal cleaning performance while 
minimizing waste and operational costs.` },
  { icon: featureIcon7, title: 'High-Performance Drying System ', video: featureVideo1, contentTitle: 'High-Performance Drying System ', content: `The advanced drying system features four top-mounted air blowers with vertical 
movement functionality, delivering up to 95% drying efficiency. Additionally, two side
mounted blowers, integrated with a dynamic tracking system, ensure thorough removal 
of residual water from all surfaces. Powered by six high-performance 5 HP motors, this 
system provides fast, uniform, and energy-efficient drying. ` },
  { icon: featureIcon8, title: 'Automation & Safety', video: featureVideo1, contentTitle: 'Automation & Safety', content:   `Equipped with advanced digital collision avoidance technology, the system ensures 
safe and reliable operation. The user-friendly HMI dashboard, remote monitoring 
capabilities, LED guidance system, and one-key reset function collectively enhance 
operational efficiency, user control, and safety.  ` },
  { icon: featureIcon9, title: 'Side blowers movement system', video: featureVideo1, contentTitle: 'Side blowers movement system', content: `The dynamic side blower movement system delivers high-velocity air streams along the 
vehicle’s sides, ensuring efficient and uniform drying. By effectively eliminating residual 
water, it helps achieve a spotless, streak-free finish with enhanced precision and 
speed. ` },
  { icon: featureIcon10, title: 'Vertical Movement System for Superior Water Removal ', video: featureVideo1, contentTitle: 'Vertical Movement System for Superior Water Removal ', content: `The vertical movement system enhances cleaning efficiency by dynamically adjusting 
airflow angles to precisely follow the vehicle's contours. By minimizing the gap between 
the blowers and the car surface, it ensures maximum water displacement and 
comprehensive rinsing from all directions. ` },
  { icon: featureIcon11, title: 'All in one integrated panel', video: featureVideo1, contentTitle: 'All in one integrated panel', content: `The all-in-one integrated control panel offers centralized, real-time system control for 
enhanced operational efficiency. With built-in remote access, it supports rapid 
diagnostics, simplified troubleshooting, and effective management ensuring smooth, 
uninterrupted car wash operations. 
` },
  { icon: featureIcon12, title: 'Voltage Stabilizer', video: featureVideo1, contentTitle: 'Voltage Stabilizer', content: `The voltage stabilizer maintains a consistent and reliable power supply, safeguarding 
the car wash system from voltage fluctuations. This protection enhances the 
performance, safety, and lifespan of all electrical components, ensuring stable and 
efficient operation. ` },
];

const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/sohvNbpVu3k';

const FeaturesSection = () => {
  const [selected, setSelected] = useState(0);
  const feature = features[selected];

  return (
    <section className="features-section container">
      <div className="features-header">
      <h2 className="features-title">
  Flawless Cleaning.<br />Minimal Contact. Lasting Shine with Professional Car Detailing Services
</h2>

<div className="features-subtitle">
  Experience our flawless German-engineered automatic car wash system, complemented by professional car detailing services
</div>
      </div>
      <div className="features-main">
        <div className="features-list">
          {features.map((f, i) => (
            <div
              className={`feature-list-item${i === selected ? ' selected' : ''}`}
              key={f.title}
              onClick={() => setSelected(i)}
            >
              <img src={f.icon} alt={f.title} className="feature-list-icon" />
              <span className="feature-list-title">{f.title}</span>
              {i === selected && <div className="feature-list-underline" />}
            </div>
          ))}
        </div>
        <div className="features-content">
          <div className="features-video-wrap">
            <iframe
              width="600"
              height="400"
              src={YOUTUBE_EMBED_URL}
              title="YouTube video player"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{
                width: '100%',
                maxWidth: 600,
                aspectRatio: '16/9',
                background: '#000',
                display: 'block',
                borderRadius: 8,
              }}
            />
          </div>
          <motion.div
            key={selected}
            className="features-content-box"
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ type: 'spring', stiffness: 60, damping: 18, duration: 0.7 }}
          >
            <div className="features-content-title">{feature.contentTitle}</div>
            <div className="features-content-desc">{feature.content}</div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 